/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import logo from '../../Recursos/Logos/logo_blanco.svg'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {CONTACTOS} from "../../Constantes";
import {irUrl} from "../../Utilidades/irUrl";


const Footer = () => {
    const {sCell} = useResponsive()


    const Bloque = ({titulo, items}) => {


        return (
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{color: '#fff'}}
                spacing={0.5}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: 1}}>
                    <Typography sx={{fontSize: 16, fontWeight: 700}}>{titulo}</Typography>
                </Grid>

                {items.map((item, index) => (
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            onClick={() => irUrl(item.url)}
                            sx={{
                                fontSize: 16,
                                fontWeight: 400,
                                cursor: 'pointer',
                                borderBottom: 1,
                                borderColor: '#ffffff00',
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                    borderColor: '#ffffff',
                                }
                            }}>{item.nombre}</Typography>
                    </Grid>
                ))}

            </Grid>
        )
    }

    return (

        <>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: theme.palette.primary.main,
                    py: 8
                }}
            >

                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{maxWidth: '1400px', px: 3}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 3}}
                                  sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: sCell ? -3 : 0}}>
                                <img src={logo} width={sCell ? 110 : 150} height={'auto'}/>
                            </Grid>


                            <Grid container size={{xs: 12, sm: 12, md: 2}}
                                  sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                                <Bloque titulo={'MARCAS'} items={[]}/>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 3}}
                                  sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                                <Bloque titulo={'CATEGORIAS'} items={[]}/>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 3}}
                                  sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                                <Bloque titulo={'CONTACTOS'} items={CONTACTOS.map((it) => {
                                    return {nombre: it.nombre + ': ' + it.descripcion, url: it.url};
                                })}/>
                            </Grid>


                        </Grid>
                    </Grid>

                </Grid>


            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'center', backgroundColor: '#000', py: 2}}>
                <Typography sx={{textAlign: 'center', color: '#fff'}}>© Copyright 2026 - 2027 | J.G Optica</Typography>
            </Grid>

        </>
    )

}
export default Footer